// extracted by mini-css-extract-plugin
export var skipAnimation = "_40-0";